import { render, staticRenderFns } from "./proof-view-compare-navigation.vue?vue&type=template&id=2a55584c&scoped=true&"
import script from "./proof-view-compare-navigation.vue?vue&type=script&lang=js&"
export * from "./proof-view-compare-navigation.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-compare-navigation.vue?vue&type=style&index=0&id=2a55584c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55584c",
  null
  
)

export default component.exports